import React, { Component } from "react";
import {
  Button,
  Form,
  Container,
  Breadcrumb,
  Divider,
  Input
} from "semantic-ui-react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import _ from "lodash";

import { APP_NAME } from "../../constants/resource.constants";
import { RegisterModel } from "../../models";
import { FB_APP_ID } from "../../constants/auth.constants";
import {
  REGISTER_ROUTE,
  HOME_ROUTE,
  MY_ACCOUNT_ROUTE,
  LOGIN_ROUTE,
  BASE_URL
} from "../../constants/route.constants";
import FacebookLogin from "../../components/FacebookLogin/FacebookLogin";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/FooterView";

export default class RegisterPage extends Component {
  constructor(props) {
    super(props);
    this.state = { errors: {} };
  }

  componentDidMount() {
    this.props.history.listen((location, action) => {
      window.scrollTo(0, 0);
    });
  }

  handleSubmit = e => {
    const model = new RegisterModel(this.state);

    const errors = model.validate();
    this.setState({ errors });
    if (!_.isEmpty(errors)) {
      return;
    }

    this.props.requestSignup({
      redirect: () => this.props.history.push(LOGIN_ROUTE),
      data: model
    });
    e.preventDefault();
    this.setState({ password: "", confirmPassword: "", captcha: "" });
  };

  FacebookLoginButton = ({ facebookLogin }) => (
    <button className="btn btn-primary" onClick={facebookLogin}>
      Login with <i className="fa fa-facebook-f" />
    </button>
  );

  onFacebookLogin = async (err, data) => {
    if (err) return;

    data.access_token = data.accessToken;

    try {
      await this.props.requestLogin({
        redirect: x => {
          const params = new URLSearchParams(this.props.location.search);
          const next = params.get("next");
          if (next) {
            this.props.history.push(next);
          } else {
            this.props.history.push(MY_ACCOUNT_ROUTE);
          }
        },
        data,
        strategy: "facebook"
      });
      this.props.history.push(HOME_ROUTE);
    } catch (error) {
      if (error.message === "Incomplete oauth registration") {
        this.props.history.push(REGISTER_ROUTE);
      } else {
        throw error;
      }
    }
  };

  render() {
    return (
      <div>
        <header>
          <NavBar {...this.props} />
        </header>
        <Container>
          <Helmet>
            <title>Register | {APP_NAME}</title>
            <meta
              name="description"
              content="Register an account with GAA International, create your profile, add your clubs or find a new one."
            />
            <link
              rel="canonical"
              href={`${BASE_URL}${window.location.pathname}`}
            />
            <meta property="og:title" content={`Register | ${APP_NAME}`} />
            <meta
              property="og:description"
              content="Register an account with GAA International, create your profile, add your clubs or find a new one."
            />
            <meta
              property="og:image"
              content="https://d3hfkx84ni8spj.cloudfront.net/misc/gaa-intl-lrg.png"
            />
            <meta
              property="og:url"
              content={`${BASE_URL}${window.location.pathname}/`}
            />
            <meta property="og:type" content="website" />
          </Helmet>
          <h1>Register</h1>
          <Breadcrumb size="small">
            <Breadcrumb.Section href={HOME_ROUTE}>Home</Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section active>Register</Breadcrumb.Section>
          </Breadcrumb>
          <Divider />
          <p>Connect with thousands of people player Gaelic Games worldwide!</p>
          <div className="container__half-width">
            <Form onSubmit={this.handleSubmit}>
              <Form.Field>
                <label>First name</label>
                {this.state.errors.firstName &&
                this.state.errors.firstName.hasError ? (
                  <span className="error">
                    {this.state.errors.firstName.message}
                  </span>
                ) : (
                  " "
                )}
                <Input
                  name="firstName"
                  onChange={e => this.setState({ firstName: e.target.value })}
                  value={this.state.firstName}
                  placeholder="First name"
                  error={
                    this.state.errors.firstName &&
                    this.state.errors.firstName.hasError
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>Surname</label>
                {this.state.errors.lastName &&
                this.state.errors.lastName.hasError ? (
                  <span className="error">
                    {this.state.errors.lastName.message}
                  </span>
                ) : (
                  " "
                )}
                <Input
                  name="lastName"
                  onChange={e => this.setState({ lastName: e.target.value })}
                  value={this.state.lastName}
                  placeholder="Surname"
                  error={
                    this.state.errors.lastName &&
                    this.state.errors.lastName.hasError
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>Email</label>
                {this.state.errors.email && this.state.errors.email.hasError ? (
                  <span className="error">
                    {this.state.errors.email.message}
                  </span>
                ) : (
                  " "
                )}
                <Input
                  name="email"
                  onChange={e => this.setState({ email: e.target.value })}
                  value={this.state.email}
                  placeholder="Email"
                  error={
                    this.state.errors.email && this.state.errors.email.hasError
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>Password</label>
                {this.state.errors.password &&
                this.state.errors.password.hasError ? (
                  <span className="error">
                    {this.state.errors.password.message}
                  </span>
                ) : (
                  " "
                )}
                <Input
                  name="password"
                  onChange={e => this.setState({ password: e.target.value })}
                  value={this.state.password}
                  placeholder="Password"
                  type="password"
                  error={
                    this.state.errors.password &&
                    this.state.errors.password.hasError
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>Confirm Password</label>
                {this.state.errors.confirmPassword &&
                this.state.errors.confirmPassword.hasError ? (
                  <span className="error">
                    {this.state.errors.confirmPassword.message}
                  </span>
                ) : (
                  " "
                )}
                <Input
                  name="password"
                  onChange={e =>
                    this.setState({ confirmPassword: e.target.value })
                  }
                  value={this.state.confirmPassword}
                  placeholder="Confirm Password"
                  type="password"
                  error={
                    this.state.errors.confirmPassword &&
                    this.state.errors.confirmPassword.hasError
                  }
                />
              </Form.Field>
              <Form.Field>
                <label>Enter the word shown below</label>
                {this.state.errors.captcha &&
                this.state.errors.captcha.hasError ? (
                  <span className="error">
                    {this.state.errors.captcha.message}
                  </span>
                ) : (
                  " "
                )}
                <img
                  src="/img/captcha.jpg"
                  alt="Captcha"
                  className="register__captcha"
                />

                <Input
                  name="captcha"
                  onChange={e => this.setState({ captcha: e.target.value })}
                  value={this.state.captcha}
                  placeholder="Enter text"
                  type="text"
                  error={
                    this.state.errors.captcha &&
                    this.state.errors.captcha.hasError
                  }
                />
              </Form.Field>
              <Button type="submit">Sign up</Button>
              <FacebookLogin
                appId={FB_APP_ID}
                fields="name,email,picture"
                onLogin={this.onFacebookLogin}
                component={this.FacebookLoginButton}
              />
            </Form>
          </div>
        </Container>
        <Footer />
      </div>
    );
  }
}

RegisterPage.defaultProps = {
  requestSignup: () => ({})
};

RegisterPage.propTypes = {
  requestSignup: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/routes/RegisterPage/RegisterPageView.js